<template>
  <div class="gender-distribution-chart">
    <div class="text-center mb-4">{{ title }}</div>
    <div class="row">
      <div class="col-md-6">
        <div class="text-center mb-3">Мэргэшсэн инженер</div>
        <apexchart
          type="donut"
          :options="miningEngineerOptions"
          :series="miningEngineerSeries"
          height="350"
        />
      </div>
      <div class="col-md-6">
        <div class="text-center mb-3">Зөвлөх инженер</div>
        <apexchart
          type="donut"
          :options="defenseEngineerOptions"
          :series="defenseEngineerSeries"
          height="350"
        />
      </div>
    </div>
    <div class="text-center mt-3">
      <div class="legend-container">
        <span class="legend-item">
          <span class="legend-color" style="background-color: #4299E1;"></span>
          Эрэгтэй
        </span>
        <span class="legend-item ml-4">
          <span class="legend-color" style="background-color: #FF69B4;"></span>
          Эмэгтэй
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";

export default {
  name: "GenderDistributionChart",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    title: {
      type: String,
      default: "Хүйсийн харьцаа"
    }
  },
  data() {
    return {
      miningEngineerSeries: [],
      defenseEngineerSeries: [],
      miningEngineerOptions: {
        chart: {
          type: "donut"
        },
        labels: ["Эрэгтэй", "Эмэгтэй"],
        colors: ["#FF69B4", "#4299E1"],
        legend: {
          show: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: "18px",
                  fontWeight: "bold",
                  formatter: function(val) {
                    return val + "%";
                  }
                },
                total: {
                  show: true,
                  showAlways: false,
                  label: "",
                  formatter: () => {
                    return this.calculatePercentage(
                      this.miningEngineerSeries,
                      0
                    );
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      },
      defenseEngineerOptions: {
        chart: {
          type: "donut"
        },
        labels: ["Эрэгтэй", "Эмэгтэй"],
        colors: ["#FF69B4", "#4299E1"],
        legend: {
          show: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: "18px",
                  fontWeight: "bold",
                  formatter: function(val) {
                    return val + "%";
                  }
                },
                total: {
                  show: true,
                  showAlways: false,
                  label: "",
                  formatter: () => {
                    return this.calculatePercentage(
                      this.defenseEngineerSeries,
                      0
                    );
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      }
    };
  },
  mounted() {
    this.loadData3();
    this.loadData4();
  },
  methods: {
    loadData3() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart3",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          // console.log(res);
          this.updateChartData(res.data, 3);
        }
      });
    },
    loadData4() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart4",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          // console.log(res);
          this.updateChartData(res.data, 4);
        }
      });
    },
    updateChartData(data, mode) {
      if (data && data.length > 0) {
        // Extract series data (counts) and calculate percentages
        const series = data.map(item => parseInt(item.count));
        const total = series.reduce((sum, val) => sum + val, 0);
        const percentages = series.map(val => Math.round((val / total) * 100));

        // Update charts with percentage data
        if (mode == 3) {
          this.miningEngineerSeries = percentages;
          // Update entire options object to trigger reactivity
          this.miningEngineerOptions = {
            ...this.miningEngineerOptions,
            labels: data.map(item => item.name + " (" + item.count + ")" || "Unknown")
          };
        } else if (mode == 4) {
          this.defenseEngineerSeries = percentages;
          // Update entire options object to trigger reactivity
          this.defenseEngineerOptions = {
            ...this.defenseEngineerOptions,
            labels: data.map(item => item.name + " (" + item.count + ")" || "Unknown")
          };
        }
      }
    },
    calculatePercentage(series, index) {
      if (!series || series.length === 0 || index >= series.length) return "0%";
      return series[index] + "%";
    }
  }
};
</script>

<style scoped>
.gender-distribution-chart {
  padding: 20px;
}

.legend-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>
